// extracted by mini-css-extract-plugin
export var contact = "DepartmentsContactsSection-module--contact--C-WPJ";
export var contactsBlock = "DepartmentsContactsSection-module--contactsBlock--9La2a";
export var contentContainer = "DepartmentsContactsSection-module--contentContainer--4dppj";
export var departmentsContactsContainer = "DepartmentsContactsSection-module--departmentsContactsContainer--zAgaQ";